import {
  Avatar,
  DataTableColumn,
  Tag,
  Timestamp,
} from '@dixa/lib-shared-habla';
import { SearchConversationEnriched, SearchUser } from 'lib-search-types';
import { conversationStatusAttributes } from 'lib-shared-legacy-types';

import { AppLink } from 'components/appLink';
import { channelAttributes } from 'utils/channels';
import { getUserDisplayName } from 'utils/user';

import styles from './styles.module.scss';

export function makeColumns(
  userSelector: (
    data: SearchConversationEnriched,
  ) => SearchUser | null | undefined,
  userLabel: 'Contact' | 'Assigned to',
): DataTableColumn<SearchConversationEnriched>[] {
  return [
    {
      label: '#',
      selector: function renderCsid(conversation) {
        return (
          <AppLink
            path="/conversation/:csid"
            params={{ path: { csid: `${conversation.id}` } }}
          >
            #{conversation.id}
          </AppLink>
        );
      },
      style: { width: 1 },
    },
    {
      label: userLabel,
      selector: function renderUser(conversation) {
        const user = userSelector(conversation);

        return (
          <div className={styles.user}>
            <Avatar user={user} />
            <div className={styles.userName}>
              {user ? getUserDisplayName(user) : 'Unknown'}
            </div>
          </div>
        );
      },
      style: { width: '30%' },
    },
    {
      label: 'Status',
      selector: function renderStatus(conversation) {
        if (!conversation.status) {
          return null;
        }
        const status = conversationStatusAttributes.get(conversation.status);
        return <Tag color={status?.color}>{status?.prettyName}</Tag>;
      },
    },
    {
      label: 'Channel',
      selector: (conversation) =>
        (conversation.initial_channel &&
          channelAttributes[conversation.initial_channel]?.name) ||
        'Unknown',
    },
    {
      label: 'Direction',
      selector: function renderDirection(conversation) {
        return (
          <div className={styles.direction}>
            {conversation.initial_direction}
          </div>
        );
      },
    },
    {
      label: 'Last update',
      selector: function renderLastUpdate(conversation) {
        return (
          conversation.last_message_created_at && (
            <Timestamp relative time={conversation.last_message_created_at} />
          )
        );
      },
    },
  ];
}
